import { helper } from '@myrealtrip/frontend-weblog';
const { sendClickLog } = helper;

export { sendClickLog };
